import angular from 'angular';

export function parseUrl(href: string, text?: unknown) {
  if (!text) {
    text = href;
  }

  return `<a href="${href}">${text}</a>`;
}

export function ParseUrlFilter(input: string, text?: unknown) {
  return parseUrl(input, text);
}

ParseUrlFilterFactory.$inject = [];

function ParseUrlFilterFactory() {
  return ParseUrlFilter;
}

export const ParseUrlFilterModule = angular
  .module('acme.common.filter.parseUrl', [])
  .filter('parseUrl', ParseUrlFilterFactory).name;
